import { DEFAULT_CURRENCY_CODE, makeEnvironmentProviders } from '@angular/core';
import {
  MatPaginatorDefaultOptions,
  MatPaginatorIntl,
  MAT_PAGINATOR_DEFAULT_OPTIONS,
} from '@angular/material/paginator';
import { LocaleService } from '@next/core-lib/i18n';

import { I18nPaginatorAdapter } from './adapters/i18n-paginator.adapter';

export function provideAppTable() {
  return makeEnvironmentProviders([
    {
      provide: MatPaginatorIntl,
      useClass: I18nPaginatorAdapter,
      deps: [LocaleService],
    },
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: {
        pageSize: 25,
        pageSizeOptions: [5, 10, 25, 50, 100],
        hidePageSize: false,
        showFirstLastButtons: true,
      } as MatPaginatorDefaultOptions,
    },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
  ]);
}
